import resultFactory from '~/utils/resultFactory'

/**
 @since 2021-12-03
 @author Jaeuk Ryu <wj_tams_dev02>
 */

export const state = () => ({
  DbmsSettingUrl: '/api/sm/auth/extdb-cm', // EXTDB 설정 URL
  DbmsSyncUrl: '/api/sm/auth/extdb-cm/sync', // EXTDB 사용여부 설정 URL
  DbmsUrl: '/api/sm/auth', // EXTDB URL
  defaultId: -1, // 설정 추가용 ID
  settingDataList: [], // 설정 데이터 리스트
  authServerDataList: [], // EXTDB 조회 리스트

  // extdbdServerResult: 'OK', // 서버 추가시 중복 테스트 용도
  selectedStoreItem: {} // 수정중인 항목 모든탭 동일
})

export const mutations = {
  clearStore: (state) => {
    state.defaultId = -1
    state.settingDataList = [] // 설정 데이터 리스트
    state.authServerDataList = [] // EXTDB 조회 리스트
    state.selectedStoreItem = []
  },
  clearServerDataList: (state) => {
    state.authServerDataList = [] // EXTDB 조회 리스트
  },
  getDefaultId: (state, data) => {
    state.defaultId = data.authsvr_extdb_cm_id
  },

  // 서버 Reference 조회
  // getServerReference: (state, item) => { // need to check
  //   // state.serverReference = item
  //   let serverRef = _.clone(state.serverReference)
  //   const keys = Object.keys(state.serverReference)
  //   _.forEach(keys, key => {
  //     if (item[key]) {
  //       serverRef[key] = item[key]
  //     } else {
  //       serverRef[key] = []
  //     }
  //   })
  //   state.serverReference = serverRef
  // },

  setSelectedStoreItem: (state, item) => {
    state.selectedStoreItem = item
  },
  getSettingDataList: (state, item) => {
    state.settingDataList = _.cloneDeep(item)
  },

  editAuthServerListDataAction: (state, data) => {
    state.settingDataList = _.map(state.settingDataList, (item) => {
      if (item.authsvr_extdb_cm_id === data.authsvr_extdb_cm_id) {
        item = _.cloneDeep(data)
        // item.protocolName = getProtocolName(item)
      }
      return item
    })
  },

  authServerHeaderMutation: (state, data) => {
    state.settingDataList = _.map(state.settingDataList, (item) => {
      item.authsvr_extdb_cm_sync_yn = data
      return item
    })
  },

  delSettingDataList: (state, item) => {
    _.forEach(item, (p) => {
      const idx = _.findIndex(state.settingDataList, {authsvr_extdb_cm_id: p.authsvr_extdb_cm_id})
      if (idx >= 0) {
        state.settingDataList.splice(idx, 1)
      }
    })
  },

  getDbmsDataList: (state, item) => {
    state.authServerDataList = _.cloneDeep(item)
  },
  addDbmsData: (state, item) => {
    state.authServerDataList.push(_.cloneDeep(item))
  },
  editDbmsData: (state, item) => {
    const idx = _.findIndex(state.authServerDataList, {authsvr_extdb_id: item.authsvr_extdb_id})
    state.authServerDataList.splice(idx, 1, item)
  },
  delDbmsDataList: (state, item) => {
    _.forEach(item, (p) => {
      const idx = _.findIndex(state.authServerDataList, {authsvr_extdb_id: p.authsvr_extdb_id})
      if (idx >= 0) {
        state.authServerDataList.splice(idx, 1)
      }
    })
  }
}

export const actions = {
  async getSettingDataList ({commit, state}) { // 인증 서버 설정 조회
    try {
      const data = await this.$axios.$get(state.DbmsSettingUrl)
      return resultFactory(commit, {length: null, data: data, action: 'getSettingDataList', param: null})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  async addSettingData ({commit, state}, payload) { // 인증 서버 통합 설정 추가
    try {
      const data = await this.$axios.$put(state.DbmsSettingUrl, payload, {successAlert: false})
      return resultFactory(commit, {length: null, data: data, action: null, param: null})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  async editSettingData ({commit, state}, payload) { // 인증 서버 통합 편집
    try {
      const data = await this.$axios.$put(state.DbmsSettingUrl, payload, {successAlert: false})
      return resultFactory(commit, {length: null, data: data, action: null, param: null})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  async delSettingDataList ({commit, state}, payload) {
    let isMulty = false
    const idList = []
    const delList = []
    if (payload.length > 1) {
      isMulty = true
    }
    payload.forEach((item) => {
      idList.push({'authsvr_extdb_cm_id': item.authsvr_extdb_cm_id})
      delList.push(item.authsvr_extdb_cm_id)
    })
    try {
      const data = isMulty ? await this.$axios.$delete(state.DbmsSettingUrl, {data: {items: delList}}, {failAlert: false})
        : await this.$axios.$delete(`${state.DbmsSettingUrl}/${payload[0].authsvr_extdb_cm_id}`)
      return resultFactory(commit, {length: idList.length, data: data, action: null, param: null})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },

  async editAuthServerDataAction ({commit, state, dispatch}, payload) {
    try {
      const data = await this.$axios.$put(state.DbmsSyncUrl, payload, {failAlert: false})
      return resultFactory(commit, {length: payload.length, data: data, action: null, param: 'edit'})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  async editAuthServerListDataAction ({commit, state, dispatch}, payload) {
    try {
      const data = await this.$axios.$put(`${state.DbmsSyncUrl}/${payload[0].authsvr_extdb_cm_id}`, _.pick(payload[0], ['authsvr_extdb_cm_sync_yn']), {failAlert: false})
      return resultFactory(commit, {length: payload.length, data: data, action: null, param: 'edit'})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },

  async getDefaultId ({commit, state}) { // 설정 추가용 ID 조회
    try {
      const data = await this.$axios.$post(state.DbmsSettingUrl, null, {successAlert: false})
      return resultFactory(commit, {length: null, data: data, action: 'getDefaultId', param: null})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  // EXTDB //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  async getDbmsDataList ({commit, state}) {
    try {
      const data = await this.$axios.$get(`${state.DbmsUrl}/${state.defaultId}/extdb`)
      return resultFactory(commit, {length: null, data: data, action: 'getDbmsDataList', param: null})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  async addDbmsData ({commit, state, dispatch}, payload) { // 인증 서버 추가.
    const param = makePayload(_.cloneDeep(payload), 'add')
    try {
      const data = await this.$axios.$post(`${state.DbmsUrl}/${state.defaultId}/extdb`, param)
      return resultFactory(commit, {length: null, data: data, action: 'addDbmsData', param: null})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  async editDbmsData ({commit, state, dispatch}, payload) {
    const param = makePayload(_.cloneDeep(payload), 'edit')
    try {
      const data = await this.$axios.$put(`${state.DbmsUrl}/${state.defaultId}/extdb/${payload.authsvr_extdb_id}`, param)
      return resultFactory(commit, {length: null, data: data, action: 'editDbmsData', param: null})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  async delDbmsDataList ({commit, state}, payload) {
    let isMulty = false
    const idList = []
    const delList = []
    if (payload.length > 1) {
      isMulty = true
    }
    payload.forEach((item) => {
      idList.push({'authsvr_extdb_id': item.authsvr_extdb_id})
      delList.push(item.authsvr_extdb_id)
    })
    try {
      const data = isMulty ? await this.$axios.$delete(`${state.DbmsUrl}/${state.defaultId}/extdb`, {data: {items: delList}}, {failAlert: false})
        : await this.$axios.$delete(`${state.DbmsUrl}/${state.defaultId}/extdb/${payload[0].authsvr_extdb_id}`)
      return resultFactory(commit, {length: idList.length, data: data, action: 'delDbmsDataList', param: idList})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  }
  // EXTDB //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
}

function makePayload (param, type) {
  const serverKeyMap = {
    name: 'extdb_svr_name',
    ip: 'extdb_svr_ip',
    port: 'extdb_svr_port',
    authsvr_extdb_id: 'authsvr_extdb_id'
  }
  const server = []
  _.forEach(param.servers, (item) => {
    server.push(_.omit(_.mapKeys(item, (value, key) => {
      return serverKeyMap[key]
    }), ['undefined', 'itemIndex']))
  })
  param.servers = server

  if (type === 'add') {
    param.authsvr_extdb_db_pw = btoa(param.db_pw)
  } else {
    if (param.db_pw.length > 0) {
      param.authsvr_extdb_db_pw = btoa(param.db_pw)
    }
  }

  const payloadKeyMap = {
    authsvr_extdb_id: 'authsvr_extdb_id',
    name: 'authsvr_extdb_name',
    servers: 'servers',
    auth_type: 'authsvr_extdb_auth_type',
    type: 'authsvr_extdb_type',
    db_name: 'authsvr_extdb_db_name',
    db_tbl: 'authsvr_extdb_db_tbl',
    db_id: 'authsvr_extdb_db_id',
    authsvr_extdb_db_pw: 'authsvr_extdb_db_pw',
    desc: 'authsvr_extdb_desc'
  }
  return _.omit(_.mapKeys(param, (value, key) => {
    return payloadKeyMap[key]
  }), ['undefined'])
}
